import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChargingStation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChargingStation"><Path d="M13.5 15.5V3.5H3.5V15.5M13.5 15.5V20.5H3.5V15.5M13.5 15.5H3.5" stroke="currentColor"/><Path d="M3.5 20.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 10.75V16.5H20.5V7.25L17.5 4.75" stroke="currentColor" strokeLinecap="square"/><Path d="M9.21429 6.28577L6 10.2143H7.78571V12.7143L11 8.78577H9.21429V6.28577Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChargingStation;
